// extracted by mini-css-extract-plugin
export default {"mCard":"VD-z","image":"WD-z","imageNoBackground":"XD-z","imageHasCategory":"YD-z","fullWidth":"ZD-z"};